"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div") `
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  overflow: auto hidden;
`;
const Heading = styled_1.default("h6") `
  margin: 0 0 ${({ theme, hasMeta }) => (hasMeta ? theme.space.base : 0)}px 0;
  font-size: ${({ theme }) => theme.font.size.small}px;
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.color.text.dark};
  line-height: 1;
`;
const Meta = styled_1.default("p") `
  margin: 0;
  font-size: ${({ theme }) => theme.font.size.fineprint}px;
  color: ${({ theme }) => theme.color.text.lightest};
  line-height: 1;
`;
const Contact = (_a) => {
    var { name, meta } = _a, props = __rest(_a, ["name", "meta"]);
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement(Heading, { hasMeta: Boolean(meta) }, name),
        React.createElement(Meta, null, meta)));
};
exports.default = Contact;
//# sourceMappingURL=Contact.js.map